var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.isLoading
      ? _c("section", { staticClass: "modal-card-body" }, [_vm._m(1)])
      : _c(
          "section",
          { staticClass: "modal-card-body p-0" },
          [
            _c("Permisos", {
              attrs: {
                documento: _vm.fileDetailed,
                "nivel-permiso-user": _vm.nivelPermisoUser,
              },
              on: { updateDocument: _vm.updateDocument },
            }),
          ],
          1
        ),
    _vm._v(" "),
    _c("footer", { staticClass: "modal-card-foot" }, [
      _c(
        "a",
        {
          staticClass: "button is-dark",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("Cerrar")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v("Permisos")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "fas fa-sync fa-spin" }),
      _vm._v("  Cargando..."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }